var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useEffect, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import { WidgetContext } from '../../App';
import { Message } from './Message';
import { getLastTimeInMessageGroup } from './helpers/getLastTimeInMessageGroup';
import * as styles from './Correspondence.module.css';
const getMessages = (api, data) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield api.getChatMessages(data).catch((err) => console.error(err));
    return [...response.items].reverse();
});
export const Correspondence = ({ setReplayMessage }) => {
    const intl = useIntl();
    const { socketService, api, widgetSettings } = useContext(WidgetContext);
    const [messages, setMessages] = useState([]);
    /** Используется чтобы после подгрузки изображений в сообщениях вызывать scrollToBottom(), т.к. картинки могут подгрузиться позже */
    const [loadedImages, setLoadedImages] = useState(0);
    const messagesEndRef = useRef(null);
    const scrollToBottom = () => {
        var _a;
        (_a = messagesEndRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth' });
    };
    useEffect(() => {
        if (!socketService || !api)
            return;
        const eventListener = {
            'new message': (message) => {
                setMessages((msgs) => [...msgs, message]);
                scrollToBottom();
            },
            'message deleted': (data) => {
                const deletedMessage = messages.find((message) => String(message.id) === String(data.id));
                if (deletedMessage) {
                    deletedMessage.deleted_at = new Date().toISOString();
                    deletedMessage.text = intl.formatMessage({ id: 'messageDeleted' });
                    setMessages([...messages]);
                }
            },
        };
        socketService.addEventListener(eventListener);
        return () => socketService.removeEventListener(eventListener);
    }, [socketService, api, messages, intl]);
    useEffect(() => {
        if ((socketService === null || socketService === void 0 ? void 0 : socketService.joinResponseData) && api) {
            const { chat_key, client_id, user_id } = socketService.joinResponseData;
            getMessages(api, { channel: 'widget', chat_key, client_id, user_id }).then((messages) => setMessages(messages));
        }
    }, [api, socketService === null || socketService === void 0 ? void 0 : socketService.joinResponseData]);
    useEffect(() => {
        scrollToBottom();
    }, [messages, loadedImages]);
    const onDeleteMessage = (messageId) => socketService === null || socketService === void 0 ? void 0 : socketService.deleteMessageEmit(messageId);
    return (_jsx("div", { className: styles.correspondenceContainer, children: _jsxs("div", { children: [messages
                    .filter((message) => !message.deleted_at)
                    .map((message, index, messagesArr) => {
                    var _a;
                    return (_jsx(Message, { message: message, index: index, messagesArr: messagesArr, backgroundColor: widgetSettings === null || widgetSettings === void 0 ? void 0 : widgetSettings.backgroundColor, clientId: (_a = socketService === null || socketService === void 0 ? void 0 : socketService.joinResponseData) === null || _a === void 0 ? void 0 : _a.client_id, lastTimeInMessageGroup: getLastTimeInMessageGroup(index, messagesArr), onDeleteMessage: onDeleteMessage, onReplayMessage: setReplayMessage, setLoadedImages: setLoadedImages }, message.id));
                }), _jsx("div", { ref: messagesEndRef })] }) }));
};
